import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RxFormGroup, RxwebValidators } from '@rxweb/reactive-form-validators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../shared/services/form.service';
import { takeUntil } from 'rxjs/operators';
import { UserModel } from '../models/users.model';
import { UsersService } from '../../../../../services/users.service';
import { FormControl } from '@angular/forms';
import { CustomersService } from '../../../../../services/customers.service';


@Component({
	selector: 'app-create-edit-user',
	templateUrl: './create-edit-user.component.html',
	styleUrls: ['./create-edit-user.component.scss']
})
export class CreateEditUserComponent implements OnInit, OnDestroy {
	@Input() data: any = {};
	formGroup: RxFormGroup;
	isEdit = false;
	changePassword = false;

	fields: any = {
		name: {
			type: 'input',
			options: {
				path: 'name',
				class: 'col-sm-12',
				label: {
					text: 'Nombre',
					class: 'col-sm-12'
				}
			}
		},
		email: {
			type: 'input',
			options: {
				path: 'email',
				class: 'col-sm-12',
				label: {
					text: 'Correo',
					class: 'col-sm-12'
				}
			}
		},
		rolName: {
			type: 'select',
			options: {
				path: 'rolName',
				class: 'col-sm-12',
				label: {
					text: 'Seleccione el Rol para el usuario',
					class: 'col-sm-12',
				},
				dropdown: {
					text: 'Seleccione...',
					options: [
						{ id: 1, name: 'admin' },
						{ id: 2, name: 'staff' },
						{ id: 3, name: 'user' }
					]
				}
			}
		},
		password: {
			type: 'password',
			options: {
				path: 'password',
				class: 'col-sm-12',
				label: {
					text: 'Contraseña',
					class: 'col-sm-12'
				}
			}
		},
		client_id: {
			type: 'select',
			options: {
				path: 'client_id',
				label: {
					text: 'Cliente'
				},
				dropdown: {
					text: 'Seleccione...',
					options: []
				}
			}
		},
		confirmPassword: {
			type: 'password',
			options: {
				path: 'confirmPassword',
				class: 'col-sm-12',
				label: {
					text: 'Confirmar Contraseña',
					class: 'col-sm-12'
				}
			}
		}
	};

	private atComponentDestroy = new Subject();

	get isImageType(): boolean {
		return this.formGroup.get('type').value;
	}

	constructor(
		private cdr: ChangeDetectorRef,
		public modalRef: BsModalRef,
		private broadcast: BroadcastService,
		private formService: FormService,
		private usersService: UsersService,
		private customersService: CustomersService
	) {
		this.changePassword = true;

		this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.formGroup = data;
			});

	}
	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	async ngOnInit(): Promise<void> {
		this.formService.transformIntoFormGroup(UserModel, this.data);
		let clientsResponse = await this.customersService.getAll();
		let clients = clientsResponse.data ?? [];
		clients = clients.map(data => ({ id: data.id, name: data.name }));
		this.fields.client_id.options.dropdown.options = [...clients];

		if (this.data?.id) {
			this.isEdit = true;
			this.changePassword = false;
			this.formGroup.addControl('changePassword', new FormControl(false));
			this.formGroup.get('rolName').setValue(this.data.roles.pivot.role_id || null);
			this.formGroup.get('client_id').setValue(this.data.client_real_id || null);

			this.setValidatorsForPassword({checked: false});
		}

		this.formGroup.valueChanges
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.cdr.markForCheck();
			});
	}

	/**
	 * Send data to the server
	 */
	submit(): void {
		console.log(this.data)
		console.log(this.formGroup)
		this.usersService.createOrUpdate(this.formGroup, this.data?.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				data => {
					// console.log(data)
					this.broadcast.reloadDataTable();
					this.modalRef.hide();
				}
			);
	}

	/**
	 * Helper function to transform an Object into an Array
	 * @param enumme
	 * @returns
	 */
	toArray(enumme): any[] {
		return Object.keys(enumme)
			.map(key => ({ id: key, name: enumme[key] }));
	}

	/**
	 * Set ReactiveForm validator for password
	 * @param $event
	 */
	setValidatorsForPassword($event: any): void {
		this.changePassword = $event.checked;

		this.formGroup.get('password').setValidators([
			RxwebValidators.required(),
			RxwebValidators.password({
			validation: {
				minLength: 5,
				maxLength: 25,
				digit: true,
				specialCharacter: true,
				lowerCase: true,
				upperCase: false
			}
			})
		]);
		this.formGroup.get('confirmPassword').setValidators([
			RxwebValidators.required(),
			RxwebValidators.password({
			validation: {
				minLength: 5,
				maxLength: 25,
				digit: true,
				specialCharacter: true,
				lowerCase: true,
				upperCase: false
			}
			}),
			RxwebValidators.compare({ fieldName: 'password' })

		]);
		if (this.isEdit && !this.changePassword) {
			this.formGroup.get('password').setValidators([]);
			this.formGroup.get('confirmPassword').setValidators([]);
		}

		this.formGroup.get('password').updateValueAndValidity();
		this.formGroup.get('confirmPassword').updateValueAndValidity();
	}

}
